import { Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { LayoutDashboard, Shield, ShieldCheck, Truck, Archive, CreditCard, Receipt, LogOut, Settings, Building2 } from "lucide-react";
import { logoutStaff } from "@/Calls/callStaffAuth";

const navLinks = [
    { to: "/admin/dashboard",             icon: LayoutDashboard, label: "Dashboard"       },
    { to: "/admin/dealers/pending",       icon: Building2,       label: "Pending Dealers" },
    { to: "/admin/insurance-companies",   icon: Shield,          label: "Insurance"        },
    { to: "/admin/warranty-companies",    icon: ShieldCheck,     label: "Warranty"         },
    { to: "/admin/transport-companies",   icon: Truck,           label: "Transport"        },
    { to: "/admin/salvage-companies",     icon: Archive,         label: "Salvage"          },
    { to: "/admin/floorplan-companies",   icon: CreditCard,      label: "Floor Plan"       },
    { to: "/admin/billing",               icon: Receipt,         label: "Billing"          },
];

export default function AdminLayout() {
    const navigate = useNavigate();
    const location = useLocation();

    const handleLogout = async () => {
        try { await logoutStaff(); } catch { /* ignore */ }
        navigate("/admin/login");
    };

    return (
        <div className="min-h-screen flex bg-gray-50">
            <aside className="w-60 bg-slate-900 text-white flex flex-col">
                <div className="px-5 py-6 border-b border-slate-700">
                    <div className="flex items-center gap-2">
                        <Settings className="h-5 w-5 text-gray-400" />
                        <span className="font-semibold text-sm">Admin Panel</span>
                    </div>
                </div>

                <nav className="flex-1 px-3 py-4 space-y-1">
                    {navLinks.map(({ to, icon: Icon, label }) => {
                        const active = location.pathname === to || location.pathname.startsWith(to + "/");
                        return (
                            <Link
                                key={to} to={to}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                                    active
                                        ? "bg-slate-600 text-white"
                                        : "text-slate-300 hover:bg-slate-800 hover:text-white"
                                }`}
                            >
                                <Icon className="h-4 w-4" />
                                {label}
                            </Link>
                        );
                    })}
                </nav>

                <div className="px-3 py-4 border-t border-slate-700">
                    <button
                        onClick={handleLogout}
                        className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-slate-300 hover:bg-slate-800 hover:text-white transition-colors w-full"
                    >
                        <LogOut className="h-4 w-4" />
                        Sign Out
                    </button>
                </div>
            </aside>

            <main className="flex-1 overflow-auto">
                <div className="p-6 max-w-6xl mx-auto">
                    <Outlet />
                </div>
            </main>
        </div>
    );
}
